import { RESOURCE_IMAGE_JD_EXAMPLES } from '../../@core/utilities/Constant'
import React, { FC } from 'react'
import LogoTags from 'src/@legacy/@optimal-page/pages/employer/headhunt-service/schema/LogoTags'
import PublicPageMeta from 'src/@legacy/@core/components/SEOMeta/PublicPageMeta'
import { LINK_URL_EMPLOYER_JD_EXAMPLES } from 'src/@legacy/utilities/LinkURL'
import { EliminateQueryCanonical } from 'src/@legacy/@core/components/SEOMeta/CanonicalMeta'
import env from 'src/@legacy/utilities/env'
import JDWrapper from './components/JDWrapper'
import BreadcrumbTags from './components/BreadcrumbTags'
import useRedirectUserLang from 'src/@legacy/@optimal-page/hooks/useRedirectUserLang'

const JDExamplesPage: FC<{ JDData }> = ({ JDData }) => {
  useRedirectUserLang()
  return (
    <>
      <EliminateQueryCanonical rootDomain={`${env.PUBLIC_EMPLOYER_APP_DOMAIN}${LINK_URL_EMPLOYER_JD_EXAMPLES}`} />
      <PublicPageMeta
        title={`${JDData.length} mẫu mô tả công việc cực chuẩn mà HR cần biết| freeC Asia`}
        description={`Tổng hợp tất cả mẫu mô tả công việc từ mọi cấp bậc cho đến mọi ngành nghề, hữu ích với cả HR dày dặn kinh nghiệm và cả những "newbie" mới bước chân vào nghề`}
        keywords=""
        image={`${env.PUBLIC_EMPLOYER_APP_DOMAIN}${RESOURCE_IMAGE_JD_EXAMPLES}`}
        url={`${env.PUBLIC_EMPLOYER_APP_DOMAIN}${LINK_URL_EMPLOYER_JD_EXAMPLES}`}
      />
      <BreadcrumbTags />
      <LogoTags />
      <JDWrapper JDData={JDData} />
    </>
  )
}
export default JDExamplesPage
